import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiUrl } from '../../constants/paths';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
  }),
  endpoints: (build) => ({
    login: build.mutation({
      query: (params) => ({
        url: apiUrl.login,
        method: 'POST',
        body: params.body,
        params: params.inviteToken
          ? {
              inviteToken: params.inviteToken,
            }
          : {},
      }),
    }),
    register: build.mutation({
      query: (params) => ({
        url: apiUrl.register,
        method: 'POST',
        body: params.body,
        params: params.inviteToken
          ? {
              inviteToken: params.inviteToken,
              source: params.source ?? '',
            }
          : {},
      }),
    }),
    google: build.mutation({
      query: (params) => ({
        url: apiUrl.google,
        method: 'POST',
        body: params.body,
        params: params.inviteToken
          ? {
              inviteToken: params.inviteToken,
              source: params.source ?? '',
            }
          : {},
      }),
    }),
    resetPassword: build.mutation({
      query: (body) => ({
        url: apiUrl.reset,
        method: 'POST',
        body: body,
      }),
    }),
    setPassword: build.mutation({
      query: (body) => ({
        url: apiUrl.setPassowrd,
        method: 'POST',
        body: body,
      }),
    }),
    mobile: build.mutation({
      query: (params) => ({
        url: apiUrl.mobile,
        method: 'POST',
        body: params.body,
        params: params.inviteToken
          ? {
              inviteToken: params.inviteToken,
              source: params.source,
              email: params.email,
            }
          : {},
      }),
    }),
    userDetails: build.mutation({
      query: (params) => ({
        url: params.inviteToken
          ? `${apiUrl.getUserDetails}`
          : apiUrl.getUserDetails,
        method: 'GET',
        headers: params.headers,
        params: params.inviteToken
          ? {
              inviteToken: params.inviteToken,
              source: params.source,
              email: params.email,
            }
          : {},
      }),
    }),
    updateUserDetails: build.mutation({
      query: (params) => ({
        url: apiUrl.getUserDetails,
        method: 'PATCH',
        body: params.body,
        headers: params.headers,
      }),
    }),
    sendOtp: build.mutation({
      query: (body) => ({
        url: apiUrl.sendOtp,
        method: 'POST',
        body: body,
      }),
    }),
    verifyOtp: build.mutation({
      query: (body) => ({
        url: apiUrl.verifyOtp,
        method: 'POST',
        body: body,
      }),
    }),
    changePassword: build.mutation({
      query: (params) => ({
        url: apiUrl.getUserDetails,
        method: 'PATCH',
        body: params.body,
        headers: params.headers,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useGoogleMutation,
  useResetPasswordMutation,
  useSetPasswordMutation,
  useMobileMutation,
  useUserDetailsMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
  useUpdateUserDetailsMutation,
  useChangePasswordMutation,
} = authApi;
